import start from './all/start'
import end from './all/end'
import InterestingMoment from './all/interesting_moment'
import TacticsChange from './all/tactics_change'
import * as GameViewMode from '../constants/GameViewMode'

export default function sliceGameOnEpisods() {
    let episods = [];

    episods = getEpisods([new InterestingMoment(calculateMinLevel())]);

    if(window.gameViewMode == GameViewMode.KeyMoments && episods.length < 8)
    {
        //добить до 8 случайными 6ми
        for(let i = 6; i >=1; i--) {
            let all3LevelEpisods = getEpisods([new InterestingMoment(i, i)]);
            let diff = 8 - episods.length;
            if(diff >= 1) {
                let additionalEpisods = getRandomEpisods(all3LevelEpisods, diff);
                episods = addEpisodes(episods, additionalEpisods); 
            }
            else {
                break
            }
        }
    }

    if(window.gameViewMode == GameViewMode.Extended && episods.length < 15)
    {
        //добить до 15 случайными 2ми
        for(let i = 4; i >=1; i--) {
            let all3LevelEpisods = getEpisods([new InterestingMoment(i, i)]);
            let diff = 15 - episods.length;
            if(diff >= 1) {
                let additionalEpisods = getRandomEpisods(all3LevelEpisods, diff);
                episods = addEpisodes(episods, additionalEpisods); 
            }
            else {
                break
            }
        }
        episods = addEpisodes(episods, getEpisods([new TacticsChange()])); 
    }

    episods = addEpisodes(episods, getEpisods([new start(), new end()])); 

    return episods;
}

function addEpisodes(existingEpisods, additionalEpisods) {
    for(var i = 0; i < additionalEpisods.length; i++) {
        let interceptions = getInterceptions(existingEpisods, additionalEpisods[i]);
        if(interceptions.length > 0) {
            let megaEpisod = combine(interceptions, additionalEpisods[i]);
            existingEpisods = exclude(existingEpisods, interceptions);
            existingEpisods = addEpisode(existingEpisods, megaEpisod)
        }
        else {
            existingEpisods = addEpisode(existingEpisods, additionalEpisods[i])
        }

    }

    return existingEpisods;
}

function getInterceptions(episods, episod) {
    var interceptions = [];
    episods.forEach((e) => {
        if(!((episod[0] > e[0] && episod[0] > e[1] && episod[1] > e[0] && episod[1] > e[1]) 
            ||
            (episod[0] < e[0] && episod[0] < e[1] && episod[1] < e[0] && episod[1] < e[1])))
            interceptions.push(e);
    });

    return interceptions;
}

function combine(episods, episod) {
    var beginings = episods.map((e) => e[0]);
    var endings = episods.map((e) => e[1]);
    var raitings = episods.map((e) => e[2]);
    beginings.push(episod[0]);
    endings.push(episod[1]);
    raitings.push(episod[2]);

    return [Math.min(...beginings), Math.max(...endings), Math.max(...raitings)];
}

function exclude(episods, episodsToExclude) {
    var filtered = episods;
    
    episodsToExclude.forEach((e) => {
        filtered = filtered.filter(function(value, index, arr){
            return value[0] != e[0] && value[1] != e[1];
        });
    });

    return filtered;
}

function addEpisode(existingEpisods, newEpisod) {
    for(var i = 0; i < existingEpisods.length; i++) {
        if(existingEpisods[i][1] > newEpisod[0]) {
            //добавить за additionalEpisods[i]
            existingEpisods.insert(i, newEpisod);
            return existingEpisods;
        }
    }

    //добавить в конец
    existingEpisods.push(newEpisod);
    return existingEpisods;
}

function getRandomEpisods(episods, count) {
    episods.sort((el1, el2) => window.rand() - window.rand());
    return episods.slice(0, Math.min(count, episods.length)).sort((el1, el2) => el1[0] - el2[0]);;
}

function getEpisods(types) {
    let episods = [];
    for(let i = 0; i < window.Json.game.length; i++) {
        let frame = window.Json.game[i];
        types.forEach(ep => {
            let episod = ep.get(frame);
            if(episod){
                if(episods.length > 0) {
                    var lastAdded = episods[episods.length-1];
                    if(episod[0] >= lastAdded[0] && episod[0] <= lastAdded[1]){
                        lastAdded[1]= episod[1];
                        lastAdded[2] = Math.max(lastAdded[2], episod[2]);
                    }
                    else
                        episods.push(episod);
                }
                else
                    episods.push(episod);
            }
        })
    }

    return episods;
}

function calculateMinLevel() {
    switch(window.gameViewMode) {
        case GameViewMode.Extended:
            return 5;
        case GameViewMode.KeyMoments:
            return 7;
    }

    throw Error("unknown game mode")
}

Array.prototype.insert = function ( index, item ) {
    this.splice( index, 0, item );
};


/** WEBPACK FOOTER **
 ** ./src/episods/episodSlicer.js
 **/